<template>
    <div class="home">
        <Intro v-if='introData'
            :intro_diagram="introData.diagram"
            :intro_title="introData.title"
            :intro_title_maxwidth="introData.title_maxwidth"
            :intro_msg="introData.msg"
            :intro_scene="introData.scene"
            :intro_btn_vr="introData.vr_url"
            :intro_btn_site="introData.site_url"
            :intro_narration="introData.narration"
            lang='cn'
        />
    </div>
</template>

<script>
// @ is an alias to /src
import Intro from "@/components/Intro.vue";
import intro_data from "@/data/intro_data_cn";

export default {
    name: "Home",
    components: {
        Intro,
    },
    props: { 
        redirect: {
            type: String,
        },
    },
    data() {
        return {
            intro_name: "",
            intro_data: intro_data,
        };
    },
    mounted(){
        if(this.redirect){
            this.$router.replace({ 
                name: 'Intro', 
                params: {
                    intro_name: this.redirect.substring(1)
                }
            });
        }
    },
    computed: {
        introData() {
            if(this.$route.params.intro_name ){
                this.intro_name = this.$route.params.intro_name;   
            }
            
            if(this.intro_name){
                let data = this.intro_data[this.intro_name] ? this.intro_data[this.intro_name] : null;
                if(!data){
                    this.$router.push({ path: 'pageNotFound' })
                }
                return data;
            }
            return {};
        },
    },
    methods: {}
};
</script>

<style>
.home {
    height: 100%;
}

.pc_only{
    display: none;
}
@media (min-width: 1200px) {
    .pc_only{
        display: inline;
    }
}
</style>